
import React, { Fragment, useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import Search from "../../components/Search/Search";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import Vector from "../../assets/images/Vector.svg";
import ApiService from "../../services/ApiService";
import MuiAlert from "../../components/Alert/Alert";
import { IFile, IReport } from "../../helpers/Interfaces";
import Download from "../../assets/images/Download.svg";
import { convertDuration, validDateField, validStringField } from "../../helpers/HelperFunctions";
import { downloadMedia, getDocumentMedia } from "../../helpers/FirebaseFunctions";
import ReactAudioPlayer from 'react-audio-player';

import "./Audio.scss";

export default function Audios() {

  const apiService = new ApiService();

  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState({ isError: false, message: "", open: false, });
  const [documents, setDocuments] = useState([] as IReport[]);
  const [audio, setAudio] = useState([] as IFile[]);
  const [filteredDocuments, setFilteredDocuments] = useState([] as IReport[]);
  const [images, setImages] = useState([] as IFile[]);
  const [selectedAccordion, setSelectedAccordion] = useState("");

  useEffect(() => {
    getReports();
  }, [])

  function getReports() {

    setLoading(true);

    apiService.getDoctorDocuments().then((result: { data: any; }) => {

      let data = result.data;

      if (!data?.isSuccessful) {
        let newShowAlert = showAlert;
        newShowAlert.isError = true;
        newShowAlert.message = data?.errorMessage;
        newShowAlert.open = true;
        setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
        return;
      }

      setDocuments(data?.documents);
      setFilteredDocuments(data?.documents)
    }).catch(() => {
      let newShowAlert = showAlert;
      newShowAlert.isError = true;
      newShowAlert.message = "Unexpected Error";
      newShowAlert.open = true;
      setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
    }).finally(() => {
      setLoading(false);
    });
  }

  function setDocumentMedia(documentMedia: IFile[]) {

    let audio = documentMedia.filter((file) => { return file.fileExtension.includes("audio") });
    let images = documentMedia.filter((file) => { return file.fileExtension.includes("image") });

    setAudio(audio);
    setImages(images);
  }

  async function getMedia(reportId: string) {
    await getDocumentMedia(reportId, setDocumentMedia)
  }

  const handleSetData = (id: string, expanded: boolean) => {
    if (selectedAccordion === id) {
      setSelectedAccordion("");
    } else {
      setSelectedAccordion(id);
      if (expanded) {
        getMedia(id);
      }
    }
  }

  const closeAlert = () => {
    let newShowAlert = showAlert;
    newShowAlert.open = false;
    setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
  }

  function resetDefault() {
    setFilteredDocuments(documents);
  }

  function search(searchedWord: string) {

    if (searchedWord.trim() === "") {
      resetDefault();
      return;
    }

    let searchArr = [] as IReport[];

    filteredDocuments.forEach((document) => {
      if (document.patientName.toLowerCase().includes(searchedWord.toLowerCase())) {
        searchArr.push(document);
      }
    })

    let distinctArr = searchArr.filter((value, index) => searchArr.indexOf(value) === index);

    setFilteredDocuments(distinctArr);
  }

  return (
    <Layout selectedIndex={3}>
      <div className="audio-container">
        <MuiAlert error={showAlert.isError} message={showAlert.message} open={showAlert.open} onClose={closeAlert} />
        <div className="container-header animated animatedFadeInUp fadeInUp">
          <span className="text">Audio Clips</span>
          <div className="elements search-box">
            <Search onChange={search} />
          </div>
        </div>
        <div className="form-box animated animatedFadeInUp fadeInUp">
          {filteredDocuments?.map((document) => {
            return (
              <div key={document.id} className="according-content animated animatedFadeInUp fadeInUp">
                <Accordion onChange={(event: React.SyntheticEvent, expanded: boolean) => handleSetData(document.mediaId, expanded)}
                  expanded={selectedAccordion == document.mediaId} className="accordion-root"
                  sx={{
                    "&.css-15v22id-MuiAccordionDetails-root": {
                      padding: "0px !important"
                    }
                  }}>
                  <AccordionSummary expandIcon={<><img src={Vector} alt="Arrow" /></>} aria-controls="panel1bh-content"
                    id="panel1bh-header">
                    <div className="acording-header">
                      <div className="data-row">
                        <span className="recording-number">{validStringField(document.patientName)}</span>
                        <span className="recording-duration">{convertDuration(document.totalDuration)}</span>
                      </div>
                      <div className="data-row">
                        <span className="recording-date-time">
                          {validDateField(document.createdDate)}
                        </span>
                        {document.status === "Draft"
                          ? (<span className="recording-status">{validStringField(document.status.toUpperCase())}</span>)
                          : (<Fragment />)
                        }
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails sx={{
                    "&.MuiAccordionDetails-root": {
                      padding: "0px 16px 14px 23px"
                    }
                  }}>
                    <div className="accordion-details">
                      <div className="wavesuffer">
                        {audio.map((audio: IFile) => {
                          return (<ReactAudioPlayer style={{ width: "100%", marginBottom: "5px" }} src={audio.fileUrl} controls />)
                        })}
                      </div>
                      <div className="illness-image">
                        {images.map((file: IFile) => {
                          return file.fileExtension.includes("image")
                            ? (uploadedImg(file))
                            : (<></>);
                        })}
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            )
          })}
        </div>
      </div>
    </Layout >
  );

  function uploadedImg(file: IFile) {
    return (<div className="img-uploaded">
      <img src={file.fileUrl} alt="File" />
      <span className="extra-tag download-content">
        <div onClick={() => { downloadMedia({ fileName: file.fileName, downloadingName: file.fileName }) }}>
          <img src={Download} alt="Download" />
        </div>
      </span>
    </div>)
  }
}


